import { useEffect, useState } from "react";
import { Alert, Spinner, Table } from "react-bootstrap";
import paymentApi from "../../api/paymentApi";

const ApprovedTransactions = () => {
  const[approvedTransactions, setApprovedTransactions] = useState([]);
  const[loading, setLoading] = useState(true);
  const[error, setError] = useState(null);

  useEffect(() => { 
    fetchApprovedTransactions();
  },[]);
  const fetchApprovedTransactions = async () => {
    try {
      const response = await paymentApi.getApprovedPaymentStatus();
      setApprovedTransactions(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching approved transactions:", error);
      setError(error.message);
      setLoading(false);
    }
  };  

  return (
     <div className="container mt-4">
      <h2 className="mb-3">Approved Transactions</h2>
      {loading && (
        <div className="text-center mt-4">
          <Spinner animation="border" role="status" variant="primary">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      {!loading && error && (
        <Alert variant="danger" className="mt-3">
          {error}
        </Alert>
      )}
       {!loading && !error && approvedTransactions.length === 0 && (
        <Alert variant="info" className="mt-3">
          No approved transactions found.
        </Alert>
      )}
       {!loading && !error && approvedTransactions.length > 0 && (
        <Table striped bordered hover responsive className="mt-3">
          <thead>
            <tr>
              <th>Transaction ID</th>
              <th>User ID</th>
              <th>User Email</th>
              <th>Credits</th>
              <th>Status</th>
              <th>Approved At</th>
            </tr>
          </thead>
          <tbody>
            {approvedTransactions.map((transaction) => (
              <tr key={transaction.transactionId}>
                <td>{transaction.transactionId}</td>
                <td>{transaction.userId}</td>
                <td>{transaction.userEmail}</td>
                <td>{transaction.creditsRequested}</td>
                <td>{transaction.status}</td>
                <td>{new Date(transaction.approvedAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  )
}

export default ApprovedTransactions
